import { getCompanyPage } from '@/api/company/companyApi';
import { computed, defineComponent, toRefs } from 'vue';
import { useFetchPage } from '@/composition/fetch';
const useCompanySelect = (loaded) => {
    const { request, state } = useFetchPage(getCompanyPage);
    request({ size: 9999999, page: 1 }).then(loaded);
    const { data, loading } = toRefs(state);
    const items = computed(() => {
        return data.value.items.map((item) => {
            return {
                text: `${item.companyName}(${item.companyId})`,
                value: item
            };
        });
    });
    return {
        items,
        loading
    };
};
export default defineComponent({
    name: 'CompanySelector',
    props: {
        coSeq: Number,
        companyId: String,
        rules: Array,
        readonly: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        const { coSeq, companyId } = toRefs(props);
        const { items, loading } = useCompanySelect(() => {
            emit('update:coSeq', value.value?.coSeq);
            emit('update:companyId', value.value?.companyId);
        });
        const value = computed(() => {
            return items.value.find(item => item.value.coSeq === coSeq?.value ||
                item.value.companyId === companyId?.value)?.value;
        });
        return {
            value,
            items,
            loading,
            selectCompany(company) {
                emit('update:coSeq', company.coSeq);
                emit('update:companyId', company.companyId);
            }
        };
    }
});
